import React from 'react';
import {NavbarComponent} from "../v2/components/navbar/navbar";
import {FooterComponent} from "../v2/components/footer/footer";
import {TopBar} from "../v2/components/topbar/topbar";

const layout = (props) => {

    return (
        <div className={'skin-1'} id='wrapper'>
            <NavbarComponent/>
            <div id='page-wrapper' className={'gray-bg'}>
                <TopBar/>
                <div className="wrapper wrapper-content animated fadeInRight mb-5">
                    <main>
                        {props.children}
                    </main>
                </div>
                <FooterComponent/>
            </div>
        </div>
    )
};

export default layout;
